import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_examgrade,
  add_examgrade,
  update_examgrade,
  delete_examgrade,
  get_examgrade_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    examgrade: [],
    examgradelist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    grade:"",
    min_percentage:"",
    max_percentage:""
  },
};

// Async Thunks for API Calls
export const fetchexamgradelist = createAsyncThunk(
    'examgrade/fetchexamgradelist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_examgrade_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchexamgrade = createAsyncThunk(
  "examgrade/fetchexamgrade",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_examgrade(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createexamgrade = createAsyncThunk(
  "examgrade/createexamgrade",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_examgrade(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateexamgrade = createAsyncThunk(
  "examgrade/updateexamgrade",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_examgrade(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteexamgrade = createAsyncThunk(
  "examgrade/deleteexamgrade",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_examgrade({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const examgradeSlice = createSlice({
  name: 'examgrades',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,grade,min_percentage,max_percentage } = action.payload;
      state.formData = { id, name,grade,min_percentage,max_percentage };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        grade:"",
        min_percentage:"",
        max_percentage:""
      };
    },
    setexamgrade(state, action) {
      state.examgrade = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchexamgradelist.fulfilled, (state, action) => {
        state.examgradelist = action.payload.data;
      })
      .addCase(fetchexamgradelist.rejected, (state, action) => {
        state.examgradelist = [];

      })

       // Fetch hostel_category
       .addCase(fetchexamgrade.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchexamgrade.fulfilled, (state, action) => {
        state.loading = false;
        state.examgrade = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchexamgrade.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createexamgrade.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createexamgrade.fulfilled, (state, action) => {
        state.addLoading = false;
        state.examgrade = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createexamgrade.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updateexamgrade.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateexamgrade.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateexamgrade.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deleteexamgrade.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteexamgrade.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteexamgrade.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setexamgrade,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = examgradeSlice.actions;
export default examgradeSlice.reducer;
